export default __webpack_public_path__ + "static/media/logo-login.bb69dec2.svg";